module.exports = "/static/images/bct-map.jpg";